import React from "react";
import styled from "@emotion/styled";
import TurbineSapling from "@ecologi/assets/icons/turbine-sapling.svg";

const EmptyBannerContainer = styled.div`
  background: ${({ theme }) => `${theme.colors.snowdrop}`};
  height: 164px;
  width: 100%;
  border-radius: 30px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  align-items: center;
  position: relative;
  @media ${({ theme }) => theme.bp.mobileDown} {
    height: 136px;
    border-radius: 18px;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const HeaderText = styled.h3`
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
  margin-bottom: 8px;
  @media ${({ theme }) => theme.bp.mobileDown} {
    font-size: 18px;
    line-height: 27px;
  }
`;

const SubtitleText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  @media ${({ theme }) => theme.bp.mobileDown} {
    font-size: 16px;
    line-height: 20px;
    max-width: 180px;
  }
`;

const StyledHeaderImage = styled(TurbineSapling)`
  width: 104px;
  height: 170px;
  position: absolute;
  bottom: -30px;
  left: -10px;
  @media ${({ theme }) => theme.bp.mobileDown} {
    width: 77px;
    height: 125px;
    bottom: -40px;
    left: -20px;
  }
`;

const ImageContainer = styled.div`
  justify-self: center;
  margin: 12px;
  align-self: center;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  @media ${({ theme }) => theme.bp.mobileDown} {
    justify-self: top;
    align-self: flex-start;
    width: auto;
    height: auto;
  }
`;

export const EmptyImpactBanner = () => (
  <EmptyBannerContainer>
    <ImageContainer>
      <StyledHeaderImage />
    </ImageContainer>

    <TitleContainer>
      <HeaderText>Watch this space</HeaderText>
      <SubtitleText>No projects have been funded yet</SubtitleText>
    </TitleContainer>
  </EmptyBannerContainer>
);
